import { gql } from 'graphql-request'

export const getMedicalEquipmentUsageStatus = gql`
  query getMedicalEquipmentUsageStatus($crm: String) {
    applications {
      medicalEquipmentUsage {
        usageStatus(crm: $crm) {
          resposta
          should_show
          submission_id
        }
      }
    }
  }
`

export const saveMedicalEquipmentUsage = gql`
  mutation saveMedicalEquipmentUsage($crm: String, $resposta: String) {
    applications {
      medicalEquipmentUsage {
        saveMedicalEquipmentUsage(crm: $crm, resposta: $resposta) {
          resposta
          submission_id
          message
        }
      }
    }
  }
`
